/// <amd-module name="Test/TestPlansLibrary/LibraryHub/Component/TestPlansLibraryPortalComponent" />
import * as React from "react";
import { TestPlansLibraryConstants } from "../Constants";
import { TestPlansLibraryConnectedComponent } from "./TestPlansLibraryConnectedView";
import { ObservableValue } from "VSS/Core/Observable";
import { IVssPageContext } from "VSS/Platform/Context";
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { IContentViewObserverModuleArgs, IFilterArgs } from "VSS/Redux/Modules/ContentViewObserver/ContentViewObserverContracts";
import { IRootProviderProps, RootProvider } from "VSS/Redux/RootProvider";
import { Filter, FilterContext } from "VSSUI/Utilities/Filter";

export interface ILibrarySagaContext {
    pageContext: IVssPageContext;
}

/**
 * TestPlansLibraryPortalComponent: The root component which renders the entire library hub view
 */
export class TestPlansLibraryPortalComponent extends VssComponent {
    private _selectedTab: ObservableValue<string>;
    private _filterArgs: IFilterArgs | undefined;
    private _rootProviderProps: IRootProviderProps<ILibrarySagaContext, any>;

    constructor(props: never, context: IVssComponentContext) {
        super(props, context);
        this._selectedTab = new ObservableValue(TestPlansLibraryConstants.TestCaseTabId);
        this._rootProviderProps = this._getRootProviderProps();
    }

    public render(): JSX.Element {
        if(!this._filterArgs) {
            this._filterArgs = {
                filter: new Filter(),
                filterToggled: new ObservableValue<boolean>(false)
            }
        }
        const contentViewObserverModuleArgs: IContentViewObserverModuleArgs = {
            filterArgs: this._filterArgs,
            selectedTab: this._selectedTab
        };
        return (
            <RootProvider {...this._rootProviderProps} contentViewObserverModuleArgs={contentViewObserverModuleArgs}>
                <FilterContext.Provider value={this._filterArgs}>
                    <div className="flex justify-center flex-grow flex-column">
                        <TestPlansLibraryConnectedComponent selectedTab={this._selectedTab} />
                    </div>
                </FilterContext.Provider>
            </RootProvider>
        );
    }

    private _getRootProviderProps(): IRootProviderProps<ILibrarySagaContext, any> {
        return {
            initialState: {},
            sagaContext: { pageContext: this.context.pageContext },
            scenarioName: "TestManagement",
            modules: []
        };
    }
}

VssComponent.register("testPlansLibraryPortalComponent", TestPlansLibraryPortalComponent);